import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import DataMapperTargetStore, { DATA_MAPPER_TARGET_ROUTE } from "./DataMapperTargetStore";
import type DataMapperProfileStateStore from "../DataMapperProfileStateStore";
import { DATA_MAPPER_STEP } from "../DataMapperProfileStateStore";

const targetStore = (rootStore: RootStore) => rootStore.dataMapperTargetViewStore as DataMapperTargetStore;
const stateStore = (rootStore: RootStore) =>
  rootStore.dataMapperProfileStateViewStore as DataMapperProfileStateStore;

/**
 * Data Mapper → Target: test, connect and save this tab's TARGET database (the
 * one an import writes into) and list its tables. Gated like the Data Source
 * route: authentication here, operator tier in the store and on every API call.
 */
const dataMapperTargetRoute: RouteType[] = [
  {
    name: DATA_MAPPER_TARGET_ROUTE,
    path: "/data-mapper/target",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Target Database",
        enableRefreshButton: true,
        component: () => import("./DataMapperTarget.Header"),
      },
      body: {
        component: () => import("./DataMapperTarget.Body"),
        grayBackground: true,
      },
    },
    group: "Data Mapper",
    searchAliases: ["data mapper target", "target database", "import target", "destination database"],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      // Recorded as the profile's last step, so the Profiles list says where it was left.
      // Read the profile's saved selection first (it may name the mapping configuration), as the editors do.
      void (async () => {
        await stateStore(rootStore)?.enterStep(DATA_MAPPER_STEP.target);
        await targetStore(rootStore)?.enter();
      })();
    },
    onExit: ({ rootStore }) => {
      void stateStore(rootStore)?.flush();
      targetStore(rootStore)?.reset();
    },
  },
];

export default dataMapperTargetRoute;
